export default {
  namespaced: true,

  state: () => ({
    env: {},
  }),

  getters: {
    GET_KEY: (state) => (key) => state.env[key],
  },
  mutations: {
    SET_ENV(state, payload) {
      state.env = Object.assign({}, payload)
    },
  },
}
